import { Component, OnInit } from '@angular/core';
import { faHandPointLeft } from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  templateUrl: 'page-not-found.component.html',
  imports: [
    FaIconComponent
  ],
  styleUrls: ['page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  // Icons
  faToHome = faHandPointLeft;

  constructor(public router: Router) { }

  ngOnInit() {
  }
}
